import React, { useEffect, useState } from "react";

import { Link ,useLocation} from "react-router-dom";
import UserService from "../../services/UserService.js";

import getNotification from "../../Redux/Action/action.js";
import { useDispatch } from "react-redux";
import AuthService from "../../services/AuthService.js";

const { REACT_APP_REDIRECT_URI } = process.env;
const { REACT_APP_UPLOAD_DATA } = process.env;

function SubNavbar() {
  const dispatch = useDispatch();
  const [logindata,setlogindata]=useState({})
const location=useLocation()
    const [showmanalysistypes,setshowmanalysistypes]=useState(false)
    const [showbanalysistypes,setshowbanalysistypes]=useState(false)
    const [showsimulatortypes,setshowsimulatortypes]=useState(false)
    const [showoptimizertypes,setshowoptimizertypes]=useState(false)
    const [showsavedscenariostypes,setshowsavedscenariostypes]=useState(false)
  return (
    <>
 
{location.pathname !== "/" && location.pathname !== "/dashboard"  && 
      <nav className="navbar navbar-expand-sm sticky-top navbar-light" style={{ zIndex: 3 ,backgroundColor:"#0A4742",color:"white"}}>
     
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className="">
          <div style={{width: "30px",height: "3px", backgroundColor:"white",margin:"6px"}}></div>
          <div style={{width: "30px",height: "3px", backgroundColor:"white",margin:"6px"}}></div>
          <div style={{width: "30px",height: "3px", backgroundColor:"white",margin:"6px"}}></div>
          </span>
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav mx-auto">
          {/* { 
            <li
              className="nav-item"                
            >
              <Link className="nav-link" to="/dashboard">
                <button className={location.pathname==="/dashboard"?"btn btn-light  noborder":"btn btn-sm  noborder"}  >
                  Dashboard
                </button>
              </Link>
            </li>} */}
            {/* {location.pathname!=="/competitiveanalysis" && 
            <li
              className={
                UserService.isLoggedIn() ? "nav-item active" : "d-none"
              }
            >
              <Link className="nav-link" to="/competitiveanalysis">
                <button className="btn btn-sm  noborder" style={{  }}>
                Competitive Analysis
                </button>
              </Link>
            </li>} */}
         
            {          UserService.hasRole(["adminrole"]) && 
            <li
              className="nav-item"                
            >
              <Link className="nav-link" to="/refreshmodel">
                <button className={location.pathname==="/refreshmodel"?"btnsubnavbarselected":"btnsubnavbar "}>
                 Refresh Model
                </button>
              </Link>
            </li>}
            {         
            <li
              className="nav-item"                
            >
              <Link className="nav-link" to="/modelperformance">
                <button className={location.pathname==="/modelperformance"?"btnsubnavbarselected":"btnsubnavbar "} >
                Model Performance
                </button>
              </Link>
            </li>}
            { 
            <li
              className="nav-item"                
            >
              <Link className="nav-link" >
                <button onClick={()=>{
                  
                    if(!showmanalysistypes){
                      setshowbanalysistypes(false)
                      setshowsimulatortypes(false)
                      setshowoptimizertypes(false)
                    }
                    
                    
                      setshowmanalysistypes(!showmanalysistypes)
                                     }} className={location.pathname==="/marketanalysis" || location.pathname==="/attamarketanalysis"?"btnsubnavbarselected":"btnsubnavbar "}  >
                  Market Analysis
                </button>
              </Link>
              {showmanalysistypes &&
                            <div className='position-absolute card p-2' style={{zIndex:10}}>
                      
                                <div className='d-flex justify-content-around'>
                                    <div className='trybtn1 mx-1'>
                                        <a href="/attamarketanalysis">ATTA</a>
                                        </div>
                                        <div className='trybtn2 mx-1'> <a href="/marketanalysis">BI | SX | ND</a> 
                                    </div>
                                    </div>
                                </div>}
            </li>}
            { 
            <li
              className="nav-item"                
            >
              <Link className="nav-link" >
                <button onClick={()=>{
                  
                  if(!showbanalysistypes===true){
                    setshowmanalysistypes(false)
                    setshowsimulatortypes(false)
                    setshowoptimizertypes(false)
                  }
                  
            
                    setshowbanalysistypes(!showbanalysistypes)
                  
                  
                    
                  }} className={location.pathname==="/brandanalysis" || location.pathname==="/attabrandanalysis"?"btnsubnavbarselected":"btnsubnavbar "}  >
                  Brand Analysis
                </button>
              </Link>
              {showbanalysistypes &&
                            <div className='position-absolute card p-2' style={{zIndex:10}}>
                      
                                <div className='d-flex justify-content-around'>
                                    <div className='trybtn1 mx-1'>
                                        <a href="/attabrandanalysis">ATTA</a>
                                        </div>
                                        <div className='trybtn2 mx-1'> <a href="/brandanalysis">BI | SX | ND</a> 
                                    </div>
                                    </div>
                                </div>}
            </li>}
            {
            <li
              className="nav-item"                
            >

              <Link className="nav-link" >
                <button onClick={()=>{
                    
                    if(!showsimulatortypes===true){
                      setshowmanalysistypes(false)
                      setshowbanalysistypes(false)
                      setshowoptimizertypes(false)
                    }
                    
                  setshowsimulatortypes(!showsimulatortypes)}}
                   className={location.pathname==="/simulator" || location.pathname==="/attasimulator"?"btnsubnavbarselected":"btnsubnavbar "}>
                Scenario Planner
                </button>
                </Link>
                {showsimulatortypes &&
                            <div className='position-absolute card p-2' style={{zIndex:10}}>
                      
                                <div className='d-flex justify-content-around'>
                                    <div className='trybtn1 mx-1'>
                                        <a href="/attasimulator">ATTA</a>
                                        </div>
                                        <div className='trybtn2 mx-1'> <a href="/simulator">BI | SX | ND</a> 
                                    </div>
                                    </div>
                                </div>}
            
            </li>}
         
            {
            <li
              className="nav-item"                
            >
              <Link className="nav-link" >
                <button
                 onClick={()=>{
                  if(!showoptimizertypes===true){
                    setshowmanalysistypes(false)
                    setshowbanalysistypes(false)
                    setshowsimulatortypes(false)
                  }
                  setshowoptimizertypes(!showoptimizertypes)}}
                   className={location.pathname==="/optimizer" || location.pathname==="/attaoptimizer"?"btnsubnavbarselected":"btnsubnavbar "}>
                Optimized Spends
                </button>
              </Link>
              {showoptimizertypes &&
                            <div className='position-absolute card p-2' style={{zIndex:10}}>
                      
                                <div className='d-flex justify-content-around'>
                                    <div className='trybtn1 mx-1'>
                                        <a href="/attaoptimizer">ATTA</a>
                                        </div>
                                        <div className='trybtn2 mx-1'> <a href="/optimizer">BI | SX | ND</a> 
                                    </div>
                                    </div>
                                </div>}
            </li>}
            
            <li
              className="nav-item"                
            >
              <Link className="nav-link" >
              <button
                 onClick={()=>{
                  if(!showoptimizertypes===true){
                    setshowmanalysistypes(false)
                    setshowbanalysistypes(false)
                    setshowsimulatortypes(false)
                    setshowoptimizertypes(false)

                  }
                  setshowsavedscenariostypes(!showsavedscenariostypes)}}
                   className={location.pathname==="/savedscenarios" || location.pathname==="/attasavedscenarios"?"btnsubnavbarselected":"btnsubnavbar "}>
                Saved Scenarios
                </button>
              
              </Link>
              {showsavedscenariostypes &&
                            <div className='position-absolute card p-2' style={{zIndex:10}}>
                      
                                <div className='d-flex justify-content-around'>
                                    <div className='trybtn1 mx-1'>
                                        <a href="/attasavedscenarios">ATTA</a>
                                        </div>
                                        <div className='trybtn2 mx-1'> <a href="/savedscenarios">BI | SX | ND</a> 
                                    </div>
                                    </div>
                                </div>}
            </li>
            {/* {
            <li
              className="nav-item"                
            >
              <Link className="nav-link" to="/eventmanagement">
                <button className={location.pathname==="/eventmanagement"?"btnsubnavbarselected":"btnsubnavbar "}>
                Event Management
                </button>
              </Link>
            </li>} */}
       
            { 
            <li
              className="nav-item"                
            >
              <Link className="nav-link" to="/savedreports">
                <button className={location.pathname==="/savedreports"?"btnsubnavbarselected":"btnsubnavbar "}>
                Saved Reports
                </button>
              </Link>
            </li>}
          

            {/* <li
                className={
                  UserService.isLoggedIn()
                    ? " dropdown nav-item active"
                    : "d-none"
                }
              >

                <div>
                  <button
                    className="btn  dropdown-toggle nav-item mt-2"
                    type="button"
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    style={{color:"white"}}
                  >
                    <i className="fas fa-clipboard-list mr-1"></i>
                    Diagnostics
                  </button>

                  <div
                    className="dropdown-menu "
                    aria-labelledby="dropdownMenuButton"
                  >
                    <a className="dropdown-item" href="/competitiveanalysis">
                      Competitive Analysis{" "}
                    </a>
                    <a className="dropdown-item" href="/brandanalysis">
                      Brand Analysis
                    </a>

                  </div>
                </div>

              </li>

              <li
                className={
                  UserService.isLoggedIn() ? "nav-item" : "d-none"
                }
              >
                <Link className="nav-link" to="/simulator">
                  <button className=" btn" style={{color:"white"}}>
                    Simulator
                  </button>
                </Link>
              </li>
              <li
                className={
                  UserService.isLoggedIn() ? "nav-item active" : "d-none"
                }
              >
                <Link className="nav-link" to="/optimizer">
                  <button className="btn btn-sm  noborder" style={{color:"white"}}>
                    Optimizer
                  </button>
                </Link>
              </li>
              <li
                className={
                  UserService.isLoggedIn() ? "nav-item active" : "d-none"
                }
              >
                <Link className="nav-link" to="/eventmanagement">
                  <button className="btn btn-sm  noborder" style={{color:"white"}}>
                  Event Management
                  </button>
                </Link>
              </li>
           
              <li
                className={
                  UserService.isLoggedIn() ? "nav-item active" : "d-none"
                }
              >
                <Link className="nav-link" to="/savedreports">
                  <button className="btn btn-sm  noborder" style={{color:"white"}}>
                    Saved Reports
                  </button>
                </Link>
              </li> */}

          </ul>

       
       
      
        </div>

     
      </nav>}
      
    </>
  );
}

export default SubNavbar;
